import { Injectable } from '@angular/core';
import { interval, Subject, timer } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DataSourcesEnum } from '../enums/DataSourcesEnum';
import { ElectionStatusEnum } from '../enums/ElectionStatusEnum';
import { PageTypeEnum } from '../enums/PageTypeEnum';
import { IDataLoaded } from '../interfaces/IDataLoaded';
import { IElectionDate } from '../interfaces/IElectionDate';
import { ISelectPage } from '../interfaces/ISelectPage';
import { DataStore } from '../models/DataStore';
import { ApiDataService } from './api-data.service';

@Injectable({
  providedIn: 'root'
})
export class ElectionService {

  public electionDates: IElectionDate[] = [];


  public electionMap: Map<string, DataStore> = new Map<string, DataStore>();

  public dataLoaded$: Subject<IDataLoaded> = new Subject<IDataLoaded>();
  public menuLoaded$: Subject<string> = new Subject<string>();
  public subTitleChanged$: Subject<string> = new Subject<string>();
  public pageChanged$: Subject<ISelectPage> = new Subject<ISelectPage>();
  public menuPhoneClick$ = new Subject();
  public voteCountUpdated$ = new Subject();
  public countDownComplete$ = new Subject();

  public isMobile = false;
  public isTablet = false;
  public isDesktop = false;
  private pollingIntervalTimer: any;
  private pollingTimer: any;
  private haElectionStatus = ElectionStatusEnum.precount;

  public selectedPage: ISelectPage = {
    electionDateString: null,
    pageType: PageTypeEnum.Loading,
    countDistrict: '',
    electionDate: null
  };
  public selectedCountDistrict = '';
  public selectedHistoryDistrict = '';
  public isElectionCounting = false;
  public startCountDateTime: Date | null = null;
  public isTestingMode = false;
  public isCountingStarted = false;
  

  constructor(private apiDataService: ApiDataService) {


    apiDataService.loadElectionDates$().subscribe(data => {
      this.electionDates = data;
      const found = this.electionDates.find(x => x.electionStatus !== ElectionStatusEnum.final);
      // console.log('Elections');
      // console.log(data);
      this.startCountDateTime = found?.electionStart ?? null;
      this.isElectionCounting = this.startCountDateTime !== null;


      this.startCountDateTime = new Date('2022-07-02T08:30:00.000Z');

      const currentDate = new Date();
      const targetDate = this.startCountDateTime ?? new Date();  // TODO
      const cDateMillisecs = currentDate.getTime();
      const tDateMillisecs = targetDate.getTime();
      const difference = tDateMillisecs - cDateMillisecs;
      if (difference < 0) {
        this.isCountingStarted = true;
      }



      this.reportDataLoaded('', DataSourcesEnum.ElectionDates);
      if (this.electionDates.length > 0)
      {
        this.menuLoaded$.next(this.electionDates[0].electionDateString);
        this.electionDates.forEach(election => {
          this.electionMap.set(election.electionDateString, new DataStore());

          const isStateWide = election.districts === null;
          apiDataService.loadHAStatic$(election.electionDateString).subscribe(data => {
            this.electionMap.get(election.electionDateString)?.addHAStatic(data);
            // console.log('HAStatic - ' + election.electionEvent);
            // console.log(data);
            this.reportDataLoaded(election.electionDateString, DataSourcesEnum.HAStatic);
          });

          if (isStateWide) {
            apiDataService.loadLCStatic$(election.electionDateString).subscribe(data => {
              this.electionMap.get(election.electionDateString)?.addLCStatic(data);
              // console.log('LCStatic - ' + election.electionEvent);
              // console.log(data);
              this.reportDataLoaded(election.electionDateString,DataSourcesEnum.LCStatic);
            });
          }

          if (election.electionStatus === ElectionStatusEnum.final) {
            // final
            const haVersion = this.electionMap.get(election.electionDateString)?.haChange?.dataVersion ?? 0
            apiDataService.loadHAChange$(election.electionDateString, haVersion).subscribe(data => {
              this.electionMap.get(election.electionDateString)?.addHAChange(data);
              this.reportDataLoaded(election.electionDateString, DataSourcesEnum.HAChange);
              // console.log('HAChange Final - ' + election.electionEvent);
              // console.log(data);
            });
            if (isStateWide) {
              apiDataService.loadLCChange$(election.electionDateString, this.electionMap.get(election.electionDateString)?.lcChange?.dataVersion ?? 0).subscribe(data => {
                this.electionMap.get(election.electionDateString)?.addLCChange(data);
                // console.log('LCChange Final - ' + election.electionEvent);
                // console.log(data);
                this.reportDataLoaded(election.electionDateString, DataSourcesEnum.LCChange);
              });
            }
          } else {
            // counting
            this.pollingTimer = interval()
            this.pollingIntervalTimer = interval(this.getPollingFrequency(election.electionDateString))
              .pipe(
                startWith(0)
              )
            .subscribe(() => {
              apiDataService.loadHAChange$(election.electionDateString, this.electionMap.get(election.electionDateString)?.haChange?.dataVersion ?? 0).subscribe(data => {
                this.electionMap.get(election.electionDateString)?.addHAChange(data);
                // console.log('HAChange Counting - ' + election.electionEvent);
                // console.log(data);
                this.reportDataLoaded(election.electionDateString, DataSourcesEnum.HAChange);
                if (data.electionStatus !== ElectionStatusEnum.final && data.electionStatus !== ElectionStatusEnum.precount) {
                  this.voteCountUpdated$.next();
                }

                // if () {
                //   clearInterval(this.pollingIntervalTimer);
                // }
              }, err => {} );

              if (isStateWide) {
                apiDataService.loadLCChange$(election.electionDateString, this.electionMap.get(election.electionDateString)?.lcChange?.dataVersion ?? 0).subscribe(data => {
                  this.electionMap.get(election.electionDateString)?.addLCChange(data);
                  // console.log('LCChange Counting - ' + election.electionEvent);
                  // console.log(data);
                  this.reportDataLoaded(election.electionDateString, DataSourcesEnum.LCChange);
                  if (data.electionStatus !== ElectionStatusEnum.final && data.electionStatus !== ElectionStatusEnum.precount) {
                    this.voteCountUpdated$.next();
                  }
                  // if () {
                  //   clearInterval(this.pollingIntervalTimer);
                  // }
                }, err => {} );
              }
            });
          }
        });
      }
    });
  }

  public countDownComplete(): void {
    this.isCountingStarted = true;
    this.countDownComplete$.next();
  }

  public getLastUpdate(electionDateString: string, isHA: boolean): Date {
    if (isHA) {
      return this.electionMap.get(electionDateString)?.haChange?.lastUpdate ?? new Date();
    }
    return this.electionMap.get(electionDateString)?.lcChange?.lastUpdate ?? new Date();
  }


  public updatePage(electionDateString: string, pageType: PageTypeEnum, countDistrict: string | null, electionDate: Date | null): void {
    this.selectedPage.electionDateString = electionDateString;
    this.selectedPage.pageType = pageType;
    this.selectedPage.countDistrict = countDistrict ?? null;
    this.selectedPage.electionDate = electionDate;
    this.pageChanged$.next({ ...this.selectedPage });
  }

  public checkMenu(): void {
    if (this.isMobile) {
      this.menuPhoneClick$.next();
    }
  }

  public reportDataLoaded(electionDateString: string, dataSource: DataSourcesEnum): void {
    if (electionDateString !== '') {
      this.electionMap.get(electionDateString)?.dataSourceLoaded(dataSource);
    }
    this.dataLoaded$.next({ 
      electionDate: electionDateString,
      dataSource: dataSource
    });
  }

  // public getElectionStatus(): ElectionStatusEnum | null {
  //   return this.dataStore.haChange?.electionStatus ?? null;
  // }

  public updateSubTitle(electionDateString: string): void {
    const found = this.electionDates.find(x => x.electionDateString === electionDateString);
    if (found) {
      this.subTitleChanged$.next(found.electionEvent);
    } else {
      this.subTitleChanged$.next('');
    }
  }

  public getPollingFrequency(electionDateString: string): number {
    return 60000;
  }


}
